<template>
  <div class="layout-user-security-info"
       v-loading="loading"
       element-loading-text="加载中，请稍等...">
    <template v-if="bindInfo">
      <AppScrollbar style="height: 100%">
        <div class="security-wrap"
             v-loading="committing"
             element-loading-text="提交中，请稍等...">
          <div class="bind-details">
            <div class="detail theme-border-hover">
              <div class="label">
                <div class="icon">
                  <i class="iconfont icon-wechat"></i>
                </div>
                <div class="text">
                  <span>微信</span>
                </div>
              </div>
              <div class="value">
                <template v-if="bindInfo.wx && bindInfo.wx.bind">
                  <span class="state is-success">
                    <span>已绑定</span>
                    <template v-if="bindInfo.wx.subscribed">
                      <el-tag size="mini"
                              type="primary">已关注</el-tag>
                    </template>
                    <template v-else>
                      <el-tag size="mini"
                              type="info">未关注</el-tag>
                    </template>
                  </span>
                  <el-divider direction="vertical"></el-divider>
                  <el-button size="mini"
                             type="text"
                             class="is-danger"
                             @click="handleUnbind">解除绑定</el-button>
                </template>
                <template v-else>
                  <span class="state is-danger">未绑定</span>
                  <el-divider direction="vertical"></el-divider>
                  <WxBind @bind-success="loadBindInfo">
                    <template #default="{show}">
                      <el-button size="mini"
                                 type="text"
                                 class="is-warning"
                                 @click="show">开始绑定</el-button>
                    </template>
                  </WxBind>
                </template>
              </div>
            </div>
          </div>
        </div>
      </AppScrollbar>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>请求数据加载失败</div>
        <el-button size="mini"
                   type="text"
                   @click="loadBindInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import AppScrollbar from '../elements/AppScrollbar'
import WxBind from './WxBind'
import Hint from '../elements/Hint'
export default {
  name: 'SecurityInfo',
  components: {
    AppScrollbar,
    WxBind,
    Hint
  },
  data () {
    return {
      loading: false,
      bindInfo: null,
      committing: false
    }
  },
  computed: mapState({
    accountObj: state => state.account
  }),
  methods: {
    loadBindInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/security/bindInfo',
        method: 'post',
        disableErrorPage: true
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.bindInfo = response.data.bindInfo || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleUnbind () {
      this.$confirm('确定要解除当前账号与微信的绑定吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/portal/security/wx/unbind',
          method: 'post',
          disableErrorPage: true
        }).then((response) => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.removeCustomize()
                this.$nextTick(() => {
                  this.loadBindInfo()
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }).catch(() => {})
    },
    removeCustomize () {
      let bindInfo = this.accountObj.bindInfo
      if (bindInfo) {
        this.$delete(bindInfo, 'customize')
      }
    }
  },
  mounted () {
    this.loadBindInfo()
  }
}
</script>

<style lang="scss">
  @import "../../styles/color";
  .layout-user-security-info {
    height: 100%;
    background-color: #fff;
    .security-wrap {
      margin: auto;
      width: 760px;
      max-width: 100%;
      padding: 20px;
      .bind-details {
        & > .detail {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border: 1px solid #ebeef5;
          padding: 15px 25px;
          & > .label {
            display: flex;
            align-items: center;
            & > .icon {
              width: 38px;
              height: 38px;
              border: 1px solid #606266;
              border-radius: 50%;
              text-align: center;
              line-height: 36px;
              i {
                color: #606266;
                font-size: 18px;
              }
            }
            & > .text {
              margin-left: 10px;
              color: #606266;
              font-size: 12px;
            }
          }
          & > .value {
            display: flex;
            align-items: center;
            .is-success {
              color: $set-success-color;
            }
            .is-warning {
              color: $set-warning-color;
            }
            .is-danger {
              color: $set-danger-color;
            }
            & > .state {
              font-size: 12px;
              .el-tag {
                margin-left: 5px;
              }
            }
          }
          & + .detail {
            margin-top: 15px;
          }
        }
      }
    }
  }
</style>
